(function () {

  const COOKIE_NAME = "tv_popup_closed";
  const SUBSCRIBED_COOKIE = "tv_newsletter_subscribed";
  const COOKIE_DURATION = 30; // jours

  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = name + "=" + value + ";expires=" + date.toUTCString() + ";path=/";
  }

  function getCookie(name) {
    return document.cookie.split("; ").some(row => row.startsWith(name + "="));
  }


  function init() {
    console.log("✅ popup JS chargé");

    const popup = document.getElementById("tv-newsletter-popup");

    console.log("🔍 popup trouvée ?", popup);

    if (!popup) return;


    // Si la personne a déjà fermé la popup, on ne l'affiche pas
    if (getCookie(COOKIE_NAME)) {
      console.log("ℹ️ popup masquée : fermeture déjà enregistrée");
      return;
    }

     // Si la personne est déjà inscrite, on ne l'affiche pas
    if (getCookie(SUBSCRIBED_COOKIE)) {
    console.log("ℹ️ popup masquée : visiteur déjà inscrit");
    return;
    }


    let popupShown = false;

 const form = document.getElementById("sib-form");

if (form) {
  form.addEventListener("submit", function () {

    setTimeout(() => {
      if (document.querySelector("#success-message:not([style*='display: none'])")) {
        setCookie(SUBSCRIBED_COOKIE, "true", 365);
        console.log("✅ inscription newsletter mémorisée");
      }
    }, 3000);

  });
}

function showPopup() {
  if (popupShown) return;

  popupShown = true;
  popup.style.display = "flex";
}


// Déclenchement après 30 secondes
setTimeout(() => {
  showPopup();
}, 30000);


// Déclenchement après 50% de scroll
window.addEventListener("scroll", () => {

  const scrollPosition = window.scrollY;
  const pageHeight = document.documentElement.scrollHeight - window.innerHeight;

  if (pageHeight > 0) {
    const scrollPercent = (scrollPosition / pageHeight) * 100;

    if (scrollPercent >= 50) {
      showPopup();
    }
  }

});

    // Fermeture popup
    const closeButtons = popup.querySelectorAll("[data-tv-close]");

    closeButtons.forEach((button) => {
      button.addEventListener("click", function () {

        popup.style.display = "none";

        // mémorisation pendant 30 jours
        setCookie(COOKIE_NAME, "true", COOKIE_DURATION);

        console.log("✅ fermeture popup enregistrée");

      });
    });

  }

  document.addEventListener("DOMContentLoaded", init);

})();